import React, { FC, memo } from "react";

import { areEqual, areEqualShallow } from "Utils/areEqual";
import { useSelector } from "react-redux";
import MapActionLinks from "Components/MapActionLinks";

interface Props {
  actionButtonsConfig: any;
  defaultActionButtonsConfig: any;
  className?: string;
  alwaysShowLearnMore?: boolean;
  highContrast?: boolean;
}
type ColorCfg = { bgColor?: string; fontColor?: string };
const colorConfig: Record<string, ColorCfg> = {};

const MapActionLinksContainer: FC<Props> = memo(
  ({
    actionButtonsConfig,
    defaultActionButtonsConfig,
    className,
    alwaysShowLearnMore,
    highContrast,
  }: Props) => {
    const { registration, isPersonalizationEnabled } = useSelector(
      (selectors: any) => selectors.analytics,
      areEqual
    );

    const isBlankOrNull = (value: string | null | undefined) => {
      return value === null || value === undefined || value === "";
    };

    if (defaultActionButtonsConfig?.register?.bgColor) {
      (Object.entries(defaultActionButtonsConfig) as Array<
        [string, ColorCfg]
      >).forEach(([action, value]) => {
        const src = actionButtonsConfig[action] as ColorCfg | undefined;

        if (isBlankOrNull(src?.bgColor) || isBlankOrNull(src?.fontColor)) {
          colorConfig[action] = {
            bgColor: value?.bgColor,
            fontColor: value?.fontColor,
          };
        } else {
          colorConfig[action] = {
            bgColor: src?.bgColor,
            fontColor: src?.fontColor,
          };
        }
      });
    }

    return (
      <MapActionLinks
        registrationEnabled={registration.enabled}
        actionButtonsConfig={actionButtonsConfig}
        actionButtonsColorConfig={colorConfig}
        className={className}
        alwaysShowLearnMore={alwaysShowLearnMore}
        highContrast={highContrast}
        isPersonalizationEnabled={isPersonalizationEnabled}
      />
    );
  },
  areEqualShallow
);
MapActionLinksContainer.defaultProps = {
  className: "",
  alwaysShowLearnMore: false,
  highContrast: false,
};
export default MapActionLinksContainer;
